import {useEffect} from 'react'
import {clearLocalStorageJSONItem, getLocalStorageJSONItem} from '@app/utils/utils'
import {useApplyShipToCountry} from '@app/hooks/use-apply-ship-to-country'

export const useExplicitShipToCountry = ({history, location, onApplied, onError} = {}) => {
    const {applyShipToCountry, isShopperContextLoading} = useApplyShipToCountry()

    useEffect(() => {
        const countryFromStorage = getLocalStorageJSONItem('countryCode')
        const urlParams = new URLSearchParams(location.search)
        const countryFromUrl = urlParams.get('country')
        const newCountryCode = countryFromStorage || countryFromUrl

        async function persistExplicitCountry() {
            if (!newCountryCode || isShopperContextLoading) return

            try {
                const result = await applyShipToCountry(newCountryCode, {
                    accepted: true,
                    triggerGtm: false
                })

                if (result.href) {
                    clearLocalStorageJSONItem('countryCode')
                    window.location.href = result.href
                    return
                }

                clearLocalStorageJSONItem('countryCode')

                if (countryFromUrl) {
                    urlParams.delete('country')
                    history.replace({
                        pathname: location.pathname,
                        search: urlParams.toString()
                    })
                }

                onApplied?.(newCountryCode)
            } catch (error) {
                onError?.(error)
            }
        }

        persistExplicitCountry()
    }, [
        applyShipToCountry,
        history,
        isShopperContextLoading,
        location.pathname,
        location.search,
        onApplied,
        onError
    ])
}
